/* CR South personalization: show Name/Number sleeve fields based on selected Personalization option */
(function () {
  function init() {
    var wrap = document.getElementById('cr-pers');
    if (!wrap) return;
    var nameField = wrap.querySelector('.cr-name');
    var numField  = wrap.querySelector('.cr-number');
    if (!nameField || !numField) return;
    var nameInput = nameField.querySelector('input');
    var numInput  = numField.querySelector('input');

    function selectedVals() {
      var vals = [];
      document.querySelectorAll('input[type=radio]:checked').forEach(function (r) { vals.push(r.value); });
      document.querySelectorAll('select').forEach(function (s) { if (s.value) vals.push(s.value); });
      return vals.join('|');
    }
    function toggle(field, input, on) {
      field.style.display = on ? '' : 'none';
      input.disabled = !on;
      input.required = on;
      if (!on) input.value = '';
    }
    function update() {
      var v = selectedVals();
      toggle(nameField, nameInput, /Name/i.test(v));
      toggle(numField,  numInput,  /Number/i.test(v));
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('input[type=radio], select')) update();
    });
    update();
    setTimeout(update, 600);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
